export default "__VITE_ASSET__C9wpvp9___"